module.exports = __webpack_public_path__ + "0ade81fb88c60b15512df9a5121f4b76.pdf";